<template>
  <div class="mt-12">
    <h2 class="text-565656 fsize18 font-semibold border-b pb-4">OTT</h2>

    <div class="grid gap-4 grid-cols-3 mt-6">
      <div
        class="cursor-pointer effecthover rounded-lg"
        v-for="(item, index) in cards"
        :key="'item -' + index"
        @click="handleClick(item.route)"
      >
        <div class="flex items-center bg-lightf4f5f6 border-round p-3">
          <div class="flex gap-4 items-center w-10/12">
            <img
              :src="item.image"
              class="object-contain w-16 h-16 bg-ec rounded-lg"
              alt="banh"
            />

            <div class="w-full">
              <h3 class="col-4f fsize14 font-medium mb-0">
                {{ item.title }}
              </h3>
            </div>
          </div>
          <div class="w-2/12 flex justify-end cursor-pointer">
            <div>
              <!-- <img
                src="@/assets/images/aright.png"
                class="w-35px rounded-full"
              /> -->
              <div
                class="flex justify-center bg-light-secondary rounded-full items-center w-10 h-10"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  svgClasses="w-5 h-5"
                  class="text-secondary font-semibold flex"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cards: [
        {
          id: "01",

          title: "Content Management",
          image: require("@/assets/images/new/content.svg"),
          route: "coming",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
